import type { ColorPickerProps } from '@workramp/ui';
import { useEffect, useState } from 'react';
import { ColorPicker } from '@workramp/ui';
import { useDebouncedCallback } from '~/hooks';

export const ColorPickerSetting = ({
  label,
  value,
  onChange,
  hideLabel,
  allowAlpha = true,
  ...props
}: ColorPickerProps) => {
  const [colorValue, setColorValue] = useState(value);

  useEffect(() => {
    setColorValue(value);
  }, [value]);

  const debouncedOnChange = useDebouncedCallback(() => onChange(colorValue));

  const onColorChange = (color: string) => {
    setColorValue(color);
    debouncedOnChange();
  };

  return (
    <ColorPicker
      hideLabel={hideLabel}
      label={label}
      allowAlpha={allowAlpha}
      value={colorValue}
      onChange={onColorChange}
      {...props}
    />
  );
};
